import { Card } from '@readcloud/component-library';
import { ImageAnnotation } from '@readcloud/data';
import React from 'react';
import isEqual from 'react-fast-compare';
import { AnnotationRendererProps } from '../types';

const cardStyle = {
  height: '100%',
  width: '100%',
  transition: 'box-shadow 100ms ease-out',
  overflow: 'hidden',
} as const;
export const ImageAnnotationViewer = React.memo(function ImageAnnotationViewer({
  height,
  width,
  id,
  data,
  dragging,
}: AnnotationRendererProps<ImageAnnotation['data'], ImageAnnotation['type']>) {
  return (
    <Card key="inner" style={cardStyle} className="inheritTransform">
      {data.url && data.url.length ? (
        <div
          className="rc-h-full rc-w-full"
          style={{
            backgroundImage: `url('${data.url}')`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: '100%',
          }}
        />
      ) : null}
    </Card>
  );
},
isEqual);
